import { Notyf } from 'notyf';

// Shared singleton so multiple toasts stack in one container instead of each
// call mounting its own overlapping container. Turbo Drive replaces <body> on
// navigation, discarding Notyf's injected container while this reference
// survives, so rebuild whenever that container is no longer in the document.
let notyf;

function notyfInstance() {
  if (!notyf || !document.querySelector(".notyf")) {
    notyf = new Notyf();
  }

  return notyf;
}

export default function flash(message, flashType) {
  const instance = notyfInstance();
  if (flashType == "success") {
    instance.success({message: message, duration: 5000, dismissible: true, background: "#0E700E", ripple: false});
  } else {
    instance.error({message: message, duration: 5000, dismissible: true, background: "#B10E1C", ripple: false});
  }
}
